import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable } from 'rxjs';
import { SsoOidcDto } from '../dtos/ssoOidcDto.interface';
import * as fromFeature from '../reducers/sso.reducer';

const debug = Debug('aumico:aumico-lib-users-fe:UsersManagementProvider');

export interface NgRxSsoProvider {
    getSsoOIDC$(): Observable<SsoOidcDto>;
}

@Injectable({
    providedIn: 'root',
})
export class NgRxDefaultSsoProvider implements NgRxSsoProvider {
    constructor(private readonly store: Store<fromFeature.SsoState>) {
        debug('provider constructed');
    }

    getSsoOIDC$(): Observable<SsoOidcDto> {
        return this.store.pipe(select(fromFeature.selectCurrentSsoProvider));
    }
}
